import React from 'react';

const VARIANTS = {
  info: {
    bg:     'rgba(37, 99, 235, 0.08)',
    border: 'rgba(37, 99, 235, 0.25)',
    text:   '#1d4ed8',
  },
  success: {
    bg:     'rgba(63, 239, 166, 0.08)',
    border: 'rgba(63, 239, 166, 0.3)',
    text:   'var(--accent)',
  },
  warning: {
    bg:     'rgba(234, 179, 8, 0.08)',
    border: 'rgba(234, 179, 8, 0.3)',
    text:   '#ca8a04',
  },
  error: {
    bg:     'rgba(239, 68, 68, 0.08)',
    border: 'rgba(239, 68, 68, 0.25)',
    text:   '#dc2626',
  },
};

const Alert = ({ children, variant = 'info', className = '' }) => {
  const v = VARIANTS[variant] || VARIANTS.info;

  return (
    <div
      className={`rounded-xl px-4 py-3 text-sm leading-relaxed ${className}`}
      style={{
        background:  v.bg,
        border:      `1px solid ${v.border}`,
        color:       v.text,
      }}
    >
      {children}
    </div>
  );
};

export default Alert;
